import { Grid, h, html as htmlGrid } from 'gridjs'
import SelectMultiple from '../components/SelectMultiple'
import ModalResumo from '../components/ModalResumo.js'
import { investimentosService } from '../services/investimentos.service.js'
import { capitalize, debounce } from 'lodash'
import Pagination from '../components/Pagination.js'
import Loader from '../components/Loader.js'
import CardBigNumbers from '../components/CardBigNumbers.js'

const { getInvestimentosPf, getMetaDadosInvestimentos } = investimentosService()
const { FormatREALVirgula } = GLOBAL

const URLS = {
	investimentos_clientes_pf_api: '/clientes/investimentos/clientes_pf_api/',
	investimentos_cards_clientes_pf_api:
		'/clientes/investimentos/todos_clientes_pf_api/',
}

const politicasInfo = [
	{
		label: 'Ultra High',
		value: 0,
	},
	{
		label: 'Private',
		value: 1,
	},
	{
		label: 'Premium',
		value: 2,
	},
	{
		label: 'Distribuição',
		value: 3,
	},
]

const defaultOPtionsPaginationLimit = [10, 25, 50, 100]
let isServLoad = false

export default {
	props: {},
	components: {
		SelectMultiple,
		ModalResumo,
		Pagination,
		Loader,
		CardBigNumbers,
	},
	emits: [],

	data() {
		return {
			totalInvestidoPorAtivo: [],
			tableInvestimentos: null,
			haveModalResumo: true,
			isLoading: false,
			isLoadingCards: false,
			query: '?',
			model: {
				filtroOfficer: [],
				filtroPolitica: null,
				filtroMin: null,
				filtroMax: null,
				paginationLimitInvestimentos: 10,
				currentPage: 1,
			},
			paginationTest: 10,
			totalRegistros: 0,
			optionsOfficers: [],
			optionsPolitica: [],
			sort: true,
			usuarios: [],
			columns: [
				{ id: 'id', name: 'ID', hidden: true },
				{ id: 'politica', name: 'Politica', hidden: true },
				{
					id: 'nome',
					name: 'Cliente PF',
					attributes: {
						'sticky-column-1': true,
						'sticky-header': true,
					},
					hidden: false,
					width: '180px',
					formatter: (cell, row) => {
						const politica = row?._cells[1]?.data

						if (cell === 'Media')
							return htmlGrid(html`<div
								class="flex items-center"
								data-totalizador>
								Média por investimento
							</div>`)
						else {
							return htmlGrid(`<div class="inline-flex items-center max-w-[180px] "  >
							<svg class="h-40 w-40 shrink-0" style="${GLOBAL.generateAvatarColor(politica)}">
									<use xlink:href="#icon_person"></use>
								</svg>
							<span class="one-line max-w-[180px]" title="${cell}">${cell || ''}</span>
						</div>`)
						}
					},
					sort: {
						compare: (a, b) => {
							if (a === 'Media' || b === 'Media') return 0
							if (a > b) {
								return 1
							} else if (a < b) {
								return -1
							} else {
								return 0
							}
						},
					},
				},
				{
					id: 'usuario_responsavel',
					name: 'Officer',
					hidden: false,
					width: '100px',
					attributes: {
						'sticky-column-2': true,
						'sticky-header': true,
						center: true,
					},
					formatter: (cell, row) => {
						if (cell) {
							return htmlGrid(`<div style="display:flex; flex-direction:column; gap:2px; width: 100%; overflow: hidden; text-overflow: ellipsis; truncate" >
							${cell
								?.map((item) => {
									const nameFormated = item
										.split('.')
										.map((word) => capitalize(word))
										.join(' ')
									return `<span class="text-center w-full">${
										nameFormated || ''
									}</span>`
								})
								.join(' ')}
						</div>`)
						} else {
							return htmlGrid(`<span></span>`)
						}
					},
				},
				{
					id: 'dados_investimento_renda_fixa',
					name: 'Renda fixa',
					width: '230px',
					attributes: {
						center: true,
					},
					formatter: (cell, row) => {
						if (cell.media) {
							return htmlGrid(`
								<div style='width: 100%;'> 
									<span style='color: black; font-weight: bold;'>${cell.media.toPrecision(
										3
									)}%</span>
								</div>	
							`)
						} else if (cell) {
							// console.log(cell)
							const { data_ipca, data_pre, data_pos, totalGlobalPorcentagem } =
								cell

							const ipcaPorcentagem = data_ipca?.porcentagem_global || 0
							const prePorcentagem = data_pre?.porcentagem_global || 0
							const posPorcentagem = data_pos?.porcentagem_global || 0

							return htmlGrid(`
							<div>
								<ul class='flex flex-col items-center font-bold text-black '>
									<li>Ipca: ${ipcaPorcentagem}</li>
									<li>Pre: ${prePorcentagem}</li>
									<li>Pos: ${posPorcentagem}</li>
								</ul>
								<span class='font-bold text-primary-pure'>Total: ${
									totalGlobalPorcentagem?.valor?.toPrecision(3) || 0
								} </span>
							</div>
						`)
						}
					},
					sort: false,
				},
			],
		}
	},

	methods: {
		openModal(id, politica) {
			this.$refs.modalResumo.OpenModalResumo({
				id,
				politica,
				atendimentoID: null,
			})
		},

		openFiltros() {
			modal_padrao_vue.openModal('investimentos_filtros')
		},

		iniciarTabelaGenerica(tableSelector, columns) {
			const table = document.querySelector(tableSelector)

			const gridInstance = new Grid({
				search: false,
				resizable: true,
				columns,
				data: [],
				autoWidth: true,
				sort: false,
				style: {
					container: {
						border: 'none',
					},
					table: {
						border: 'none',
						'white-space': 'nowrap',
					},
					tr: { border: 'none' },
					th: {
						'border-bottom': '1px solid #e9ecef',
						padding: '8px 8px',
					},
					td: {
						'border-bottom': '1px solid #e9ecef',
						color: '#495057',
						'font-family': 'Roboto Flex',
						'font-size': '13px',
						'font-weight': 500,
						'line-height': '150%',
						'letter-spacing': '-0.28px',
						padding: '4px',
						'text align': 'center',
					},
					footer: { border: '' },
				},

				language: {
					search: { placeholder: 'Busque aqui...' },
					pagination: { previous: ' Anterior', next: 'Próximo ' },
				},
			})

			gridInstance?.render(table)
			return gridInstance
		},

		iniciartableInvestimentos() {
			this.tableInvestimentos = this.iniciarTabelaGenerica(
				'#table_investimentos',
				this.columns
			)
		},

		async buscaDataApiInvestimentoComfiltro() {
			this.setQueryUrl()
			const { data } = await axios.get(
				`${URLS.investimentos_clientes_pf_api}${this.query}`
			)

			return data
		},

		async buscaCardsApiInvestimentosBigNumber() {
			this.setQueryUrl()
			const { data } = await axios.get(
				`${URLS.investimentos_cards_clientes_pf_api}${this.query}`
			)

			return data
		},

		openModalOnBotton(dados) {
			// this.openModal(id, politica)
		},

		formatValorBr(valor) {
			const numero = Number(valor)

			if (!Number.isNaN(numero)) {
				return (
					'$ ' + valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
				)
			}
		},

		formDataInvestimentosTotal(data) {
			return data.count ?? 0
		},

		formatDataInvestimentosTable(data) {
			// console.log(data)

			// func para achatar o array tipos de investimentos para um objeto com campos para cada item do array
			const dataTransformado = data.results.map((dataItem) => {
				const tiposInvestimentos = dataItem.tipos_investimento.reduce(
					(tiposInvestimentosFields, tipoInvestimento) => {
						tipoInvestimento = {
							...tiposInvestimentosFields,
							[tipoInvestimento.tipo_investimento]: {
								valor: tipoInvestimento.percentual,
								isSort: true,
							},
						}

						return tipoInvestimento
					},
					{}
				)

				const { tipos_investimento, ...clientePf } = { ...dataItem }
				return { ...clientePf, ...tiposInvestimentos }
			})

			if (dataTransformado.length > 0) {
				let totaisValores = {}

				Object.entries(data.media_investimentos_por_ativo).forEach(
					([keyMedia, valueMedia]) => {
						totaisValores[keyMedia] = {
							valor: valueMedia,
							isSort: false,
						}
					}
				)

				totaisValores['dados_investimento_renda_fixa'] = {
					media: data.media_investimentos_por_ativo['Renda Fixa'],
				}

				dataTransformado.forEach((itemDataTransformado) => {
					itemDataTransformado['dados_investimento_renda_fixa'] = {
						...itemDataTransformado.dados_investimento_renda_fixa,
						totalGlobalPorcentagem: itemDataTransformado['Renda Fixa'] || {
							valor: 0,
							isSort: false,
						},
					}
				})

				dataTransformado.push({ nome: 'Media', ...totaisValores })
			}

			// console.log(dataTransformado)
			this.totalRegistros = data.count

			return dataTransformado
		},

		async setValuesInvestimentos() {
			const responseMetadadosInvestimentos = await getMetaDadosInvestimentos()
			this.setFiltroInvestimentos(responseMetadadosInvestimentos)
			/* this.setColunasInvestimentos(responseMetadadosInvestimentos) */
		},
		setFiltroInvestimentos(data) {
			this.optionsOfficers = data?.todos_users
				.map((itemUser) => {
					return {
						label: itemUser.name,
						value: itemUser.id,
					}
				})
				.filter((itemUser) => itemUser.label && itemUser.label.length > 1)

			this.optionsPolitica = politicasInfo

			const urlParams = new URLSearchParams(window.location.search)
			const users = urlParams.get('user')?.trim().split(',')
			const page = urlParams.get('page')?.trim()
			const page_size = urlParams.get('page_size')?.trim()

			this.model.currentPage = page ?? this.model.currentPage
			this.model.paginationLimitInvestimentos =
				page_size ?? this.model.paginationLimitInvestimentos

			this.model.filtrarInvestimentos =
				users
					?.map((itemUser) => parseInt(itemUser))
					.filter((itemUser) => {
						return this.optionsOfficers.find(
							(itemOfficer) => itemOfficer.value === itemUser
						)
					}) || []
		},

		setColunasInvestimentos(data) {
			/* this.columns.push(
			this.optionsPolitica = politicasInfo

			const tiposInvestimentos =
				responseMetadadosInvestimentos.tipos_investimento
			this.columns.push(
				...tiposInvestimentos
					.filter((tipoInvestimentos) => tipoInvestimentos !== 'Renda Fixa')
					.map((tipoInvestimentoColumn) => {
						return {
							id: tipoInvestimentoColumn,
							name: tipoInvestimentoColumn,
							width: '5rem',
							minWidth: '5rem',
							attributes: {
								'contet-column': true,
								title: tipoInvestimentoColumn,
							},
							formatter: (cell, row) => {
								if (cell && !isNaN(cell.valor)) {
									const valorPorcetagemInvestimento = cell.valor.toPrecision(3)

									if (row?._cells[2]?.data === 'Media') {
										return htmlGrid(
											`
									<div style='width: 100%; height: 50px; '> 
										<span style='color: black; font-weight: bold;'>${valorPorcetagemInvestimento}%</span>
									</div>	
									`
										)
									}

									const lightnessMax = 90
									const lightnessMin = 30

									const lightness =
										lightnessMax -
										(cell.valor / 100) * (lightnessMax - lightnessMin)
									const colorBg = `hsl(0, 80%, ${lightness}%)`

									return htmlGrid(
										`
								<div style='background-color:${colorBg}; width: 100%; height: 100%; color: white;'> 
									<span>${valorPorcetagemInvestimento}%</span>
								</div>	
								`
									)
								} else {
									return htmlGrid(`<span style='color: black;'>0</span>`)
								}
							},
							sort: {
								compare(a, b) {
									let auxA = a?.valor
									let auxB = b?.valor

									if (a && !a.isSort) {
										return 0
									}

									if (isNaN(auxA)) {
										auxA = 0.0
									}

									if (isNaN(auxB)) {
										auxB = 0.0
									}

									if (auxA > auxB) {
										return 1
									} else if (auxA < auxB) {
										return -1
									}
									return 0
								},
							},
						}
					})
			) */
		},

		async updateTabelaInvestimentos() {
			try {
				if (this.tableInvestimentos) {
					this.isLoading = true
					this.isLoadingCards = true
					const responseClienteInvestimentos =
						await this.buscaDataApiInvestimentoComfiltro()

					const dataTransformado = this.formatDataInvestimentosTable(
						responseClienteInvestimentos
					)

					this.updateColumnsTabelaInvestimentops(responseClienteInvestimentos)

					this.tableInvestimentos
						?.updateConfig({
							data: dataTransformado,
							columns: this.columns,
						})
						?.forceRender()

					this.$nextTick(async () => {
						try {
							const responseCardInvestimentos =
								await this.buscaCardsApiInvestimentosBigNumber()

							this.formatCardsBigNumbers(responseCardInvestimentos)
						} catch (e) {
							console.log(e)
						} finally {
							this.isLoadingCards = false
						}
					})
				}
			} catch (err) {
				console.error(err)
			} finally {
				this.isLoading = false
			}
		},

		updateColumnsTabelaInvestimentops(dataInvestimento) {
			const tiposInvestimentos =
				this.filtraColunasZeradasDataTransformado(dataInvestimento)

			this.columns = this.columns.slice(0, 5)

			this.columns.push(
				...tiposInvestimentos
					.filter((tipoInvestimentos) => tipoInvestimentos !== 'Renda Fixa')
					.map((tipoInvestimentoColumn) => {
						return {
							id: tipoInvestimentoColumn,
							name: tipoInvestimentoColumn,
							width: '5rem',
							minWidth: '5rem',
							attributes: {
								'contet-column': true,
								title: tipoInvestimentoColumn,
							},
							formatter: (cell, row) => {
								if (cell && !isNaN(cell.valor)) {
									const valorPorcetagemInvestimento = cell.valor.toFixed(2)

									if (row?._cells[2]?.data === 'Media') {
										return htmlGrid(
											`
								<div style='width: 100%; height: 50px; '> 
									<span style='color: black; font-weight: bold;'>${valorPorcetagemInvestimento}%</span>
								</div>  
								`
										)
									}

									const lightnessMax = 90
									const lightnessMin = 30

									const lightness =
										lightnessMax -
										(cell.valor / 100) * (lightnessMax - lightnessMin)
									const colorBg = `hsl(0, 80%, ${lightness}%)`

									return htmlGrid(
										`
							<div style='background-color:${colorBg}; width: 100%; height: 100%; color: white;'> 
								<span>${valorPorcetagemInvestimento}%</span>
							</div>  
							`
									)
								} else {
									return htmlGrid(`<span style='color: black;'>0</span>`)
								}
							},
							sort: {
								compare(a, b) {
									let auxA = a?.valor
									let auxB = b?.valor

									if (a && !a.isSort) {
										return 0
									}

									if (isNaN(auxA)) {
										auxA = 0.0
									}

									if (isNaN(auxB)) {
										auxB = 0.0
									}

									if (auxA > auxB) {
										return 1
									} else if (auxA < auxB) {
										return -1
									}
									return 0
								},
							},
						}
					})
			)
		},

		filtraColunasZeradasDataTransformado(dataInvestimento) {
			return Object.keys(dataInvestimento.media_investimentos_por_ativo)
		},

		setQueryUrl() {
			const urlSearchParams = new URLSearchParams()

			this.query = '?'

			const idUsers = this.model?.filtroOfficer?.map(
				(user) => user.value || user
			)

			const userJoin = idUsers?.filter((idUser) => idUser)?.join(',')

			if (userJoin) {
				urlSearchParams.append('user', userJoin)
			}

			if (
				Array.isArray(this.model?.filtroPolitica) &&
				this.model?.filtroPolitica?.length > 0
			) {
				const politicasJoin = this.model?.filtroPolitica?.map(
					(itemPolitica) => itemPolitica.value
				)
				urlSearchParams.append('politica', politicasJoin)
			}
			if (this.model?.filtroMin) {
				urlSearchParams.append('minimo', this.model?.filtroMin)
			}
			if (this.model?.filtroMax) {
				urlSearchParams.append('maximo', this.model?.filtroMax)
			}

			urlSearchParams.append('page', this.model.currentPage)
			urlSearchParams.append(
				'page_size',
				this.model.paginationLimitInvestimentos
			)

			this.query += urlSearchParams.toString()

			window.history.pushState({}, '', this.query)
		},

		async filtrarInvestimentos() {
			this.model.currentPage = 1
			isServLoad = false
			this.closeFiltroInvestimentos()
			await this.updateTabelaInvestimentos()
			//window.location.href = `${window.location.origin}/clientes/investimentos/clientes_pf/${this.query}`
		},

		limparFiltroInvestimentos() {
			this.model = {
				filtroOfficer: null,
				filtroPolitica: null,
				filtroMin: null,
				filtroMax: null,
			}
			window.location.href = `${window.location.origin}/clientes/investimentos/clientes_pf/`
		},

		closeFiltroInvestimentos() {
			const filtroInvestimentos = document.getElementById(
				'close_filtro_investimentos'
			)

			if (filtroInvestimentos) {
				filtroInvestimentos.click()
			}
		},

		async addChangeHandlerPaginationLimitFilter(e) {
			this.model.currentPage = 1
			isServLoad = false
			await this.$nextTick()
			await this.updateTabelaInvestimentos()
			isServLoad = true
		},

		formatCardsBigNumbers(data) {
			const {
				total_investido_por_ativo,
				media_investimentos_por_ativo_todos_clientes,
				media_dados_investimento_renda_fixa_total,
			} = data

			this.totalInvestidoPorAtivo = Object.entries(
				total_investido_por_ativo
			).map(([chave, valor]) => {
				const mediaCategoria =
					media_investimentos_por_ativo_todos_clientes[chave]

				const ativo = {
					label: chave,
					mediaTotal: mediaCategoria,
					valorTotal: valor,
				}
				if (chave === 'Renda Fixa') {
					ativo.subRenda = media_dados_investimento_renda_fixa_total
				}

				return ativo
			})

			console.log(this.totalInvestidoPorAtivo)
		},

		getScrollElement() {
			return this.$refs.gridContainer?.querySelector('.gridjs-wrapper')
		},
		scrollUp() {
			window.scrollBy({ top: -50, behavior: 'smooth' })
		},
		scrollDown() {
			window.scrollBy({ top: 50, behavior: 'smooth' })
		},
		scrollLeft() {
			const container = this.getScrollElement()
			if (container) container.scrollBy({ left: -50, behavior: 'smooth' })
		},
		scrollRight() {
			const container = this.getScrollElement()
			if (container) container.scrollBy({ left: 50, behavior: 'smooth' })
		},
		investimentoFormated(investimento) {
			if (
				investimento == '-' ||
				investimento?.toString().toLowerCase() == 'none'
			)
				return '-'
			const value = FormatREALVirgula(investimento.toString())
			return value
		},
	},
	computed: {
		maxPagesTable() {
			return this.totalRegistros / this.model.paginationLimitInvestimentos
		},
		totalInvestidoPorAtivoView() {
			if (this.totalInvestidoPorAtivo) {
				const aux = this.totalInvestidoPorAtivo.map((item) => {
					const ativo = {
						titulo: item.label,
						totalValor: item.valorTotal,
						totalPorcent: item.mediaTotal,
					}

					if (item.label === 'Renda Fixa') {
						ativo.subTipo = {
							Ipca: item.subRenda.data_ipca.toFixed(2),
							Pre: item.subRenda.data_pre.toFixed(2),
							Pos: item.subRenda.data_pos.toFixed(2),
							Total: (
								item.subRenda.data_pre +
								item.subRenda.data_pos +
								item.subRenda.data_ipca
							).toFixed(2),
						}
					}

					return ativo
				})

				console.log(aux)

				return aux
			}

			return []
		},
	},
	watch: {
		'model.currentPage': {
			async handler(newValue, oldValue) {
				const auxCurrentPage =
					typeof newValue === 'string' ? parseInt(newValue) : newValue
				const auxOldPage =
					typeof oldValue === 'string' ? parseInt(oldValue) : oldValue

				if (auxCurrentPage !== auxOldPage && isServLoad) {
					await this.updateTabelaInvestimentos()
				}
				isServLoad = true
			},
		},
	},

	async mounted() {
		this.setQueryUrl()
		this.iniciartableInvestimentos()
		await this.updateTabelaInvestimentos()
		await this.setValuesInvestimentos()
		document
			.getElementById('choice_pagination_investimentos')
			.addEventListener('change', this.addChangeHandlerPaginationLimitFilter)
	},
	delimiters: ['{*', '*}'],
}
